module.exports = {
  visibility: false,
  title: 'Material',
  icon: 'box-full',
  iconPrefix: 'fas',
  color: '#7dd771',
  // badgeColor: 'olive',
  tabs: []
};
